<div class="bg-dark min-h-screen">
  <div class="container mx-auto px-4 py-16 text-light">
    <div class="max-w-4xl mx-auto">
      <h1 class="text-4xl md:text-5xl font-bold mb-6 text-primary text-center">Over Ons</h1>
      
      <div class="space-y-6 mb-12">
        <p class="text-lg md:text-xl text-gray-300 leading-relaxed">
          Welkom bij Kansino Nederland, uw betrouwbare gids voor online casino en gaming in Nederland.
        </p>
        <p class="text-gray-300 leading-relaxed">
          Wij zijn gespecialiseerd in het beoordelen en vergelijken van de beste online casino platforms,
          zodat u een weloverwogen keuze kunt maken.
        </p>
        <p class="text-gray-300 leading-relaxed">
          Ons team van experts test en evalueert regelmatig verschillende platforms op basis van
          veiligheid, bonussen, gebruikerservaring en klantenservice.
        </p>
      </div>

      <!-- Features Grid -->
      <div class="grid md:grid-cols-2 gap-6 mt-12">
        <div class="bg-dark-light p-6 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-light">Betrouwbare Reviews</h3>
          </div>
          <p class="text-gray-400">
            Onze experts testen en evalueren elke casino platform grondig voordat we ze aanbevelen.
          </p>
        </div>

        <div class="bg-dark-light p-6 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-light">Exclusieve Bonussen</h3>
          </div>
          <p class="text-gray-400">
            Ontvang exclusieve welkomstbonussen en speciale aanbiedingen via onze links.
          </p>
        </div>

        <div class="bg-dark-light p-6 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-primary/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-light">Veiligheid Eerst</h3>
          </div>
          <p class="text-gray-400">
            We beoordelen alleen platforms met geldige licenties en bewezen veiligheidsmaatregelen.
          </p>
        </div>

        <div class="bg-dark-light p-6 rounded-lg border border-light/10">
          <div class="flex items-center mb-4">
            <div class="w-12 h-12 bg-accent/20 rounded-lg flex items-center justify-center mr-4">
              <svg class="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-light">24/7 Ondersteuning</h3>
          </div>
          <p class="text-gray-400">
            Ons team staat altijd klaar om u te helpen met vragen of problemen.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

